import React, { Component, createRef } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import Wizard from "./helpers/Wizard";
import * as actions from "../actions";
import ShortEnrollmentDisplay from "./short_enrollment/ShortEnrollmentDisplay";
import { Fragment } from "react";

class ShortEnrollment extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            submitted: false,
            pdfUrl: false,
            ltcFormItems: null,
        };

        // Debug for localhost:3000
        // COMMENT THIS OUT FOR PRODUCTION
        // props.activateConsumerForm('yes');
    }

    onSubmit = async (values) => {
        const reactState = this;
        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }

        /*values = {
      "patientSignatureDate": "October 21, 2021",
      "personalRepresentativeDate": "October 21, 2021",
      "prescriberAgentSignatureDate": "October 21, 2021",
      "prescriberAgentSignatureTwoDate": "October 21, 2021",
      "prescriberAgentSignatureThreeDate": "October 21, 2021",
      "prescriberAgentSignatureFourDate": "October 21, 2021",
      "dob": "2016-01-01T05:00:00.000Z",
      "phoneNumber": "1112223333",
      "diagnosis": "Hallucinations and delusions associated with PD psychosis",
      "cgPhoneNumber": "3333333333",
      "insPhoneNumber": "4444444444",
      "doctorPhoneNumber": "5555555555",
      "undefinedDate": "October 21, 2021",
      "personalRepresentative": "data:image/png;base64,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",
      "patientFirstName": "Jeremy",
      "patientLastName": "Went",
      "patientAddress": "3000",
      "patientCity": "England",
      "patientState": "AK",
      "patientZip": "12345",
      "patientEmail": "email@rando.com",
      "phoneOne": "111",
      "phoneTwo": "222",
      "phoneThree": "3333",
      "diagnosisRadio": "Other diagnosis",
      "cgFirstName": "Bob",
      "cgLastName": "Random",
      "cgEmail": "step3@cg.com",
      "cgPhoneOne": "333",
      "cgPhoneTwo": "333",
      "cgPhoneThree": "3333",
      "insDrugPan": "Presc drig plan",
      "insPhoneOne": "444",
      "insPhoneTwo": "444",
      "insPhoneThree": "4444",
      "cardHolderName": "insurance",
      "insIdNumber": "55555",
      "insMedIdNumber": "555555",
      "doctorName": "Dr. step 5 name",
      "doctorPhoneOne": "555",
      "doctorPhoneTwo": "555",
      "doctorPhoneThree": "5555",
      "agreeToHipaaAuth": true,
      "patientSignature": "data:image/png;base64,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",
      "personalRepresentativeCheck": true,
      "descriptionOfAuthority": "Desc auth"
    }*/

        values.patientResides = "Null";
        values.formType = "shortenrollment";
        values.patientResides = "someData";
        values.agreeToReceive = sessionStorage.getItem("agreeToReceive");
        values.userType =
            values.agreeToReceive != undefined && values.agreeToReceive == 1
                ? "caregiver"
                : "patient";
        sessionStorage.clear();
        sessionStorage.setItem("agreeToReceive", 0);

        //console.log(values);

        try {
            await Axios({
                method: "post",
                url: url + "api/generate_pdf",
                data: values,
                headers: {
                    "Content-type": "application/x-www-form-urlencoded",
                },
            }).then(function (res) {
                reactState.setState({
                    ...reactState.state,
                    pdfUrl: url + res.data.file,
                    submitted: true,
                });

                document.querySelector(".thank-message").style.display = "block";
                document.querySelector(".please-visit").style.display = "block";
                document.querySelector(".welcome-message").style.display = "none";
                document.querySelector("#enrollment-short-buttons").style.display = "none";

            });
            window.scrollTo({ top: 10, behavior: "smooth" });
            //this.toTop.current.scrollIntoView({ behavior: "smooth" });
        } catch (errors) {
            console.log("errors", errors);
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            ltcFormItems: {
                [name]: value,
            },
        });
    };

    toTop = createRef();

    render() {
        const { submitted, pdfUrl } = this.state;
        const formIdentifier = "ShortEnrollment";

        return (
            <Fragment>
                {this.props.consumerFormActive === "yes" && (
                    <Fragment>
                        
                        <div className="container-fluid white-bg">
                            <div className="container">
                                <div className="acadia-form" id="ltc-form">
                                    <div id="formTop" ref={this.toTop}>
                                        <div className="row">
                                            <div className="col-lg-4 show-time-mobile hide-on-submit">
                                                <div class="row spacer-medium mobile-sm"></div>
                                                <div className="floating-cta">
                                                    <div className="placeholder">
                                                        <a href="tel:18447372223">
                                                            {/* <img src="/images/floating-cta-pg-placeholder.png" /> */}
                                                            <div>
                                                                we're with you
                                                                <br />
                                                                at every step
                                                            </div>
                                                            <div>
                                                                Need help with
                                                                the enrollment
                                                                process? We're
                                                                here.
                                                                <br />
                                                                Call us at{" "}
                                                                <span
                                                                    style={{
                                                                        textDecoration:
                                                                            "underline",
                                                                    }}
                                                                >
                                                                    1-844-737-2223
                                                                </span>
                                                            </div>
                                                        </a>
                                                        <div>
                                                            Monday&ndash;Friday,
                                                            8:00 am to 8:00 pm
                                                            ET
                                                        </div>
                                                        <div class="row spacer-large mobile">
                                                            &nbsp;
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-8" id="form-column">
                                                <div class="row spacer-medium desktop-sm">
                                                    &nbsp;
                                                </div>

                                                <Wizard
                                                    onSubmit={this.onSubmit}
                                                    noOfPages={1}
                                                    formIdentifier={
                                                        formIdentifier
                                                    }
                                                    toTop={this.toTop}
                                                    submitted={submitted}
                                                    customSubmitLabel="SUBMIT APPLICATION"
                                                >
                                                    <Wizard.Page>
                                                        <ShortEnrollmentDisplay
                                                            submitted={
                                                                submitted
                                                            }
                                                            pdfUrl={pdfUrl}
                                                        />
                                                    </Wizard.Page>
                                                </Wizard>
                                                <div className="row spacer-large hide-on-submit">
                                                    &nbsp;
                                                </div>
                                                <div className="row spacer-medium hide-on-submit">
                                                    &nbsp;
                                                </div>
                                            </div>
                                            <div className="col-md-4 show-time-desktop hide-on-submit">
                                                <div class="row spacer-medium desktop-sm">
                                                    &nbsp;
                                                </div>
                                                <div className="floating-cta">
                                                    <div className="placeholder">
                                                        <a href="tel:18447372223">
                                                            {/* <img src="/images/floating-cta-pg-placeholder.png" /> */}
                                                            <div>
                                                                we're with you
                                                                <br />
                                                                at every step.
                                                            </div>
                                                            <div>
                                                                Need help with
                                                                the enrollment
                                                                process? We're
                                                                here.
                                                                <br />
                                                                Call us at&nbsp;
                                                                <span>
                                                                    1-844-737-2223
                                                                </span>
                                                            </div>
                                                        </a>
                                                        <div>
                                                            Monday&ndash;Friday,
                                                            8:00 am to 8:00 pm
                                                            ET
                                                        </div>
                                                        <div class="row spacer-large mobile">
                                                            &nbsp;
                                                        </div>
                                                        <div class="row spacer-large mobile">
                                                            &nbsp;
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
                {this.props.consumerFormActive === "no" && (
                    <Fragment>
                        <div class="row spacer-medium">&nbsp;</div>
                        <div className="container-fluid white-bg ">
                            <div className="container patient-no-prescription">
                                <div class="row spacer-medium"></div>
                                <div class="row">
                                    <div class="col-12">
                                        <h3 className="blue-font-35-gelo">
                                            get started today.
                                        </h3>
                                        <div class="row spacer-small">
                                            &nbsp;
                                        </div>
                                        <p>
                                            In order to enroll in Acadia
                                            Connect, you or your loved one will
                                            need a NUPLAZID prescription. Please
                                            visit{" "}
                                            <a
                                                class="underline-link"
                                                href="https://nuplazid.com"
                                                target="_blank"
                                            >
                                                NUPLAZID.com
                                            </a>{" "}
                                            for more information and download a
                                            Treatment Discussion Guide to start
                                            the conversation with your
                                            healthcare provider.
                                        </p>
                                        <div class="row spacer-medium">
                                            &nbsp;
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <p class="copy-bold-medium-blue">
                                            Doctor Discussion Guide
                                        </p>
                                        <p>
                                            Getting help starts with talking with your doctor. Learn how to start the conversation.
                                        </p>
                                        <a
                                            class="button blue"
                                            target="_blank"
                                            href="/nuplazid/pdf/treatment-discussion-guide.pdf"
                                        >
                                            <span class="nobr">
                                                DOWNLOAD (
                                                <i
                                                    class="fa fa-file-pdf-o"
                                                    aria-hidden="true"
                                                ></i>{" "}
                                                PDF)
                                            </span>
                                        </a>
                                        <div class="row spacer-medium mobile">
                                            &nbsp;
                                        </div>
                                    </div>
                                  
                                    <div class="col-md-12">
                                        <div class="row spacer-medium">
                                            &nbsp;
                                        </div>
                                        <p>
                                            Please read full{" "}
                                            <a
                                                href="https://nuplazid.com/pdf/nuplazid-prescribing-information.pdf"
                                                target="_blank"
                                                className="underline-link"
                                            >
                                                Prescribing Information
                                            </a>
                                            , including <b>Boxed WARNING</b>.
                                        </p>
                                    </div>
                                </div>
                                <div class="row spacer-large">&nbsp;</div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return { consumerFormActive: state.consumerFormActive };
};

export default connect(mapStateToProps, actions)(ShortEnrollment);
